export default "__VITE_ASSET__CRrdsBiL__"